module.exports = __webpack_public_path__ + "static/media/fenster_zu_active.4041b573.jpg";